<!--
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-18 16:01:10
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-04-19 08:37:14
 * @FilePath: /m-ai.nongji360.com/src/views/HistorySpark/RecordList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<van-list
		class="topic-list"
		v-model="loading"
		:finished="finished"
		finished-text="没有更多了"
		@load="getList()"
	>
		<van-cell v-for="(item,index) in topicList" :key="index">
			<div class="item" @click="topicClick(item)">
				<img class="icon" src="@/assets/images/spark/duihua_icon.png">
				{{ item.title }}
			</div>
		</van-cell>
	</van-list>
</template>

<script>
	export default {
		data() {
			return {
				loading:true,
				finished:false,
				topicList:[],
				pageNum:1,
				pageSize:20,
				pages:0,
			}
		},
		created(){
			this.getList();
		},
		methods: {
		/**
			* @description: 获取历史会话记录
			* @return {*}
			*/			
			async getList(){
				const { pageNum,pageSize,pages}  = this;
				const { totalCount,content } = await this.$http.spark.getTopicList({pageNum,pageSize});
				this.loading = false;
				this.pages = Math.ceil(totalCount/pageSize);
				this.topicList = this.topicList.concat(content);
				if(this.pages>=pageNum){
					this.finished = true;
				}
				this.pageNum = pageNum + 1;
			},
			topicClick(item){
				this.$router.push({ path:"/",query:{topicId:item.id} })
			},

		}
	}
</script>

<style lang="scss" scoped>
	.topic-list{
		padding: 0 15px;
		background: #ffffff;
		.item{
			display: flex;
			align-items: center;
			height: 35px;
			font-size: 16px;
			color: #323333;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			.icon{
				width: auto;
				height: 16px;
				margin-right: 2px;
			}
		}
	}
</style>